<template>
	<v-dialog
		v-model="showDialog"
		:max-width="maxWidth"
		:fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
		:transition="$vuetify.breakpoint.smAndDown ? 'scroll-y-reverse-transition' : ''"
		@click:outside="closeDialog"
	>
		<template v-if="requireBtn" v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-plus</v-icon>
				工程データ作成
			</v-btn>
		</template>
		<v-card :tile="$vuetify.breakpoint.smAndDown" id="card" class="large-process-dialog">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ toolbarTitle }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<ValidationError :errors="errors" />
				<v-sheet elevation="0" class="mt-4">
					<LargeProcessForm
						ref="processForm"
						:current_company_name="current_company_name"
						:large_process_types="largeProcessTypes"
						:large_process_type="largeProcessType"
						:large_process.sync="large_process"
						:order_individual_infos="orderIndividualInfos"
						:order_individual_info="order_individual_info"
						:requiredOrderIndividualInfo="requiredOrderIndividualInfo"
						:readonly="readonly"
						:disabled="disabled"
						:fileResetFlag="fileResetFlag"
						@submit-form="submitForm($event)"
						@is-window-size-check="$emit('is-window-size-check', true)"
						@add-files="addFiles($event)"
					/>
					<slot name="bottom-area" />
				</v-sheet>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import ValidationError from "../../shared/ValidationError.vue"
import LargeProcessValueForm from "./LargeProcessValueForm.vue"
import LargeProcessForm from "./LargeProcessForm.vue"

export default {
	components: {
		ValidationError,
		LargeProcessValueForm,
		LargeProcessForm,
	},
	props: {
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		toolbarTitle: {
			type: String,
			default: "追加項目",
			required: false,
		},
		requiredFetch: {
			type: Boolean,
			default: false,
		},
		large_process_types: {
			type: Array,
			required: false,
			default: () => [],
		},
		plannedStartDate: {
			type: String,
			required: false,
		},
		plannedEndDate: {
			type: String,
			required: false,
		},
		order_individual_info: {
			type: Number,
			required: false,
		},
		order_individual_infos: {
			type: Array,
			required: false,
			default: () => [],
		},
		largeProcessType: {
			type: Number,
			required: false,
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
		current_company_name: {
			type: String,
			required: false,
		},
		requiredOrderIndividualInfo: {
			type: Boolean,
			required: false,
			default: true,
		},
		requireBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			rules: rules,
			common: common,
			opened: false,
			valid: false,
			orderIndividualInfos: [],
			largeProcessTypes: [],
			large_process: {
				large_process_type_id: null,
				order_individual_info_id: null,
				start_date: null,
				end_date: null,
				start_time: null,
				end_time: null,
				planned_start_date: null,
				planned_end_date: null,
				planned_start_time: null,
				planned_end_time: null,
				schedule_start_date: null,
				schedule_end_date: null,
				schedule_start_time: null,
				schedule_end_time: null,
				team_member_id: null,
				team_id: null,
				lock_flag: false,
				memo: null,
				large_process_values_attributes: [],
			},
			errors: [],
			dialogByBtn: false,
			files: [],
			fileResetFlag: false,
		}
	},
	methods: {
		fetchData() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/large_processes/new", { headers })
				.then((res) => {
					this.authority = res.data.authority
					this.largeProcessTypes = res.data.large_process_types
					this.orderIndividualInfos = res.data.order_individual_infos.map((o) => ({
						id: o.id,
						name: common.productNameWithProductNumber(o),
					}))
					this.current_company_name = res.data.current_company_name
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm(schedule_arrangement_flag) {
			const headers = authenticate.setHeader()
			let formData = new FormData()

			let large_process = _.cloneDeep(this.large_process)
			if (!schedule_arrangement_flag) {
				delete large_process.schedule_arrangement_attributes
			}

			console.log(large_process)

			const largeProcessData = JSON.stringify(large_process)
			formData.set("large_process", largeProcessData)

			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"files" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}
			axios
				.post("/erp/v1/large_processes", formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "工程を作成しました。",
					})
					this.$emit("create-process", {
						large_process: res.data,
						schedule_arrangement_flag: schedule_arrangement_flag,
					})
					this.closeDialog()
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
		addFiles(files) {
			this.files = files
		},
		closeDialog() {
			this.showDialog = false
			this.resetForm()
		},
		resetForm() {
			this.$refs.processForm.$refs.form.reset()
			this.fileResetFlag = true
			this.large_process.large_process_type_id = this.largeProcessType
		},
	},
	mounted() {
		this.large_process.planned_start_date = this.plannedStartDate ? this.plannedStartDate : null
		this.large_process.planned_end_date = this.plannedEndDate ? this.plannedEndDate : null
		this.large_process.order_individual_info_id = this.order_individual_info
		this.largeProcessTypes = this.large_process_types
		this.large_process.large_process_type_id = this.largeProcessType ? this.largeProcessType : null
		if (this.requireBtn) {
			this.fetchData()
		} else {
			this.orderIndividualInfos = this.order_individual_infos.map((o) => ({
				id: o.id,
				name: common.productNameWithProductNumber(o),
			}))
		}
	},
	watch: {
		plannedStartDate(newVal, _) {
			this.large_process.planned_start_date = newVal
		},
		plannedEndDate(newVal, _) {
			this.large_process.planned_end_date = newVal
		},
		order_individual_info(newVal, _) {
			this.large_process.order_individual_info_id = newVal
		},
		order_individual_infos(newVal, _) {
			this.orderIndividualInfos = newVal.map((o) => ({
				id: o.id,
				name: common.productNameWithProductNumber(o),
			}))
		},
		large_process_types(newVal, _) {
			this.largeProcessTypes = newVal
		},
		deep: true,
	},
	computed: {
		showDialog: {
			get() {
				if (this.requireBtn) {
					return this.dialogByBtn
				} else {
					return this.dialog
				}
			},
			set(newVal) {
				if (this.requireBtn) {
					this.dialogByBtn = newVal
				} else {
					return this.$emit("update:dialog", newVal)
				}
			},
		},
		// start() {
		// 	// min-date に明日の9時を指定
		// 	const start = moment().add(1, "days").hour(8)
		// 	return start.format("YYYY-MM-DDTHH:mm:ss")
		// },
		// end() {
		// 	// max-date に min-date から3ヶ月後を指定
		// 	const start = moment(this.start)
		// 	const end = start.add(3, "months").endOf("day")
		// 	return end.format("YYYY-MM-DDTHH:mm:ss")
		// },
	},
}
</script>

<style lang="scss">
@import "../../../stylesheet/variable.scss";
.large-process-dialog {
	.date-time-picker {
		.field-input {
			border: solid 1px #a8a8a8 !important;
			box-shadow: none !important;
		}
		@media (min-width: $xs) {
			width: 48% !important;
			margin: 0 !important;
			margin-bottom: 20px !important;
		}
	}
}
.field-input {
	border: solid 1px #a8a8a8 !important;
	box-shadow: none !important;
}
.date-time-picker {
	@media (min-width: $xs) {
		width: 49.6% !important;
		margin-bottom: 20px !important;
	}
	.fc-toolbar-title {
		@media (max-width: $xs) {
			font-size: 1.2em !important;
		}
	}
	.fc-button {
		@media (max-width: $xs) {
			font-size: 0.6em !important;
		}
	}
}
</style>
